import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SystemAdvisoriesForm from './SystemAdvisoriesForm';
import { showSuccessNotification } from "../../../../../swzutils";
const TabSystemAdvisories = ({ tenantId }) => {
    const onSaveCompleted = () => {
        showSuccessNotification('System Advisories successfully updated');
    };
    return (_jsx(SystemAdvisoriesForm, { entityName: "tenants", entityId: tenantId, showCancelButton: false, onSaveCompleted: onSaveCompleted }));
};
export default TabSystemAdvisories;
